import styled from 'styled-components';
import colors, { opacify } from '../../utils/colors';
import { heights } from '../../utils/theme';
import { StyledText } from '../Text/Text.styles';
const { grey } = colors;
export const StyledBrand = styled.div(({ theme, renderonsidebar }) => [
    {
        height: heights.header,
        flexShrink: 0,
        display: 'flex',
        backgroundColor: 'inherit',
        color: theme.color,
        gap: '0.75rem',
    },
    renderonsidebar && {
        padding: '0 1.75rem',
        borderBottom: `1px solid ${opacify(grey, 0.3)}`,
    },
]);
export const StyledSidebarToggle = styled.button(({ theme }) => ({
    border: 'none',
    backgroundColor: 'inherit',
    padding: '0.5rem 0 0',
    svg: {
        margin: 0,
        color: theme.color,
    },
}));
export const StyledAppLink = styled.a(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    color: theme.color,
    svg: {
        marginRight: '0.5rem',
        paddingRight: '0.5rem',
        fill: theme.color,
    },
}));
export const StyledAppName = styled(StyledText)({
    marginTop: '0.5rem',
});
